export const environment = {
  production: false,
  name: 'staging',
  apiUrl: 'https://api.airgateway.work/',
  keycloakUrl: 'https://auth.airgateway.work',
  tracerUrl: 'https://tracer-api.airgateway.work',
  bpUrl: 'https://web.bookingpad.work/',
};
